import React from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import DateTimePicker from "react-datetime";

bootstrapUtils.addStyle(Button, "light-blue");

function RoundEdit(props) {
  const { round, onChange, onUpdate } = props;
  console.log('round', round);
  console.log('round.start_date', round.start_date);

  return (
    <tr>
      <td className="text-center v-align-middle instructor-round-number b-r">
        {round.number}
      </td>
      <td className="b-l b-r">
        <DateTimePicker
          dateFormat="MM/DD/YYYY"
          timeFormat={false}
          inputProps={{
            placeholder: "Date: MM/DD/YYYY",
            className: "form-control instructor-datetime-control"
          }}
          value={round.start_date}
          onChange={dt => onChange(dt, round.id, "start_date")}
        />
        <DateTimePicker
          dateFormat={false}
          timeFormat="hh:mm A"
          inputProps={{
            placeholder: "Time: HH:MM AM/PM",
            className: "form-control instructor-datetime-control"
          }}
          value={round.start_date}
          onChange={dt => onChange(dt, round.id, "start_date")}
        />
      </td>
      <td className="b-l b-r">
        <DateTimePicker
          dateFormat="MM/DD/YYYY"
          timeFormat={false}
          inputProps={{
            placeholder: "Date: MM/DD/YYYY",
            className: "form-control instructor-datetime-control"
          }}
          value={round.end_date}
          onChange={dt => onChange(dt, round.id, "end_date")}
        />
        <DateTimePicker
          dateFormat={false}
          timeFormat="hh:mm A"
          inputProps={{
            placeholder: "Time: HH:MM AM/PM",
            className: "form-control instructor-datetime-control"
          }}
          value={round.end_date}
          onChange={dt => onChange(dt, round.id, "end_date")}
        />
      </td>
      <td className="b-l">
        <Button bsStyle="light-blue" onClick={() => onUpdate(round.id)} block>
          Update
        </Button>
      </td>
    </tr>
  );
}

export default RoundEdit;



// WEBPACK FOOTER //
// ./src/instructor/components/round-edit.js